export const encryptCreditVendorPassword = async (password, publicKey) => {
	const keyData = publicKey.replace(
		/-----BEGIN PUBLIC KEY-----|-----END PUBLIC KEY-----|\s/g,
		""
	);
	const keyBytes = Uint8Array.from(atob(keyData), (character) =>
		character.charCodeAt(0)
	);
	const key = await window.crypto.subtle.importKey(
		"spki",
		keyBytes,
		{ name: "RSA-OAEP", hash: "SHA-256" },
		false,
		["encrypt"]
	);
	const encrypted = await window.crypto.subtle.encrypt(
		{ name: "RSA-OAEP" },
		key,
		new TextEncoder().encode(password)
	);

	return btoa(String.fromCharCode(...new Uint8Array(encrypted)));
};
